import type { ButtonHTMLAttributes } from "react";
import { useCadForm } from "./formContext";
export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> { variant?: "primary" | "ghost" | "danger" }
export function Button({ variant = "primary", className = "", ...rest }: ButtonProps): JSX.Element {
  const cad = useCadForm();
  // CAD formunda kutulu 22 px düğmeler (README §2.1); kâğıtta eski .btn-* sınıfları
  const v = cad
    ? variant === "primary" ? "cad-btn-primary" : variant === "danger" ? "cad-btn-box !text-[#B42318]" : "cad-btn-box"
    : variant === "primary" ? "btn-primary" : variant === "danger" ? "btn bg-bad/10 text-bad hover:bg-bad/20" : "btn-ghost";
  return <button type="button" className={`${v} ${className}`} {...rest} />;
}
